import React from 'react';

import { Loader } from '@cision/rover-ui';

import FilterPanel from '../../../../../pages/Influencers/components/FilterPanel';

import PersistentFilter from '../../../../PersistentFilter/PersistentFilter';

const PersistentWidgetFilter = ({
  id,
  name,
  onClick,
  isMultiValue,
  areFilterValuesLoading,
}) => {
  return (
    <FilterPanel
      data-qa="vSSN9NZr3ZB-eOWoAEhJO"
      defaultExpanded={false}
      title={name}
      key={id}
      id={id}
      showClearButton={false}
      onClick={onClick}
    >
      {areFilterValuesLoading && <Loader />}
      {!areFilterValuesLoading && (
        <PersistentFilter widgetFilterId={id} isMultiValue={isMultiValue} />
      )}
    </FilterPanel>
  );
};

export default PersistentWidgetFilter;
